<template>
    <detailed-message
        :has-details="message.hasDetails"
        :message-id="message.id">
        <template slot="summary" slot-scope="{toggle, isOpen}">
            <message-summary
                :message="message"
                :is-open="isOpen"
                :type="type"
                :entity-id="entityId"
                @click="e => toggle(e)"/>
        </template>
        <template slot="details">
            <div class="grid-fitted grid-unstackable timeline-message-summary">
                <message-action
                    v-for="(item, index) in message.extraData.actions"
                    class="grid-item grid-item-full"
                    :key="index"
                    :action="item.action"
                    :entity-id="item.messageId"/>
            </div>
        </template>
    </detailed-message>
</template>

<script>
    import {vIcon, vIconButton} from '@/components/form/index';
    import messagesMixins from '@/components/timeline/components/messages/messages-mixins';
    import DetailedMessage from '@/components/timeline/components/detailed-message';
    import MessageSummary from '@/components/timeline/components/message-summary/generic-summary';
    import MessageAction from '@/components/timeline/components/messages/email-message/message-details-action';

    export default {
        name: 'email-message-details',
        mixins: [messagesMixins],
        props: {
            type: {
                type: String,
                required: true,
            },
            entityId: {
                type: String,
                required: true,
            },
        },
        components: {
            vIconButton,
            vIcon,
            DetailedMessage,
            MessageSummary,
            MessageAction,
        },
    };
</script>
